import { Link, useNavigate } from 'react-router-dom'
import { Sun, Moon, Globe } from 'lucide-react'
import { MagneticButton } from '@/components/ui'
import { useTheme } from '../../../contexts/ThemeContext'
import { useLocale } from '../../../hooks/useLocale'
import { useAuthStore } from '../../../stores/authStore'
import { useHeaderState } from '../useHeaderState'

export function IdTopShell() {
  const { isDark, toggleTheme } = useTheme()
  const { locale, toggleLocale } = useLocale()
  const { isAuthenticated } = useAuthStore()
  const { scrolled, hidden } = useHeaderState()
  const navigate = useNavigate()

  return (
    <header
      className={[
        'fixed top-0 left-0 right-0 z-50',
        'flex items-center justify-between px-6 h-16',
        'transition-all duration-300 ease-out',
        scrolled
          ? 'backdrop-blur-xl bg-[var(--lukhas-deep-space)]/80 border-b border-white/5 shadow-lg shadow-black/10'
          : 'bg-transparent',
        hidden ? '-translate-y-full' : 'translate-y-0',
      ].join(' ')}
      role="banner"
    >
      {/* Logo */}
      <Link
        to="/"
        className="flex items-center gap-2 text-[var(--lukhas-text-primary)] hover:text-[var(--lukhas-lambda-blue)] transition-colors"
      >
        <span className="font-display font-thin text-xl tracking-widest text-white">
          &Lambda;iD
        </span>
      </Link>

      {/* Right-side controls */}
      <div className="flex items-center gap-3">
        {/* Theme toggle */}
        <button
          onClick={toggleTheme}
          className="p-2 rounded-lg text-[var(--lukhas-text-secondary)] hover:text-[var(--lukhas-text-primary)] hover:bg-white/5 transition-colors"
          aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
        >
          {isDark ? <Sun size={18} /> : <Moon size={18} />}
        </button>

        {/* Locale toggle */}
        <button
          onClick={toggleLocale}
          className="p-2 rounded-lg text-[var(--lukhas-text-secondary)] hover:text-[var(--lukhas-text-primary)] hover:bg-white/5 transition-colors flex items-center gap-1"
          aria-label={`Switch language to ${locale === 'en' ? 'Spanish' : 'English'}`}
        >
          <Globe size={18} />
          <span className="text-xs font-medium uppercase">{locale}</span>
        </button>

        {/* Auth CTA — MagneticButton with spring-physics cursor attraction */}
        {isAuthenticated ? (
          <MagneticButton
            domain="id"
            variant="primary"
            size="sm"
            accentColor="#14b8a6"
            onClick={() => navigate('/dashboard')}
          >
            Dashboard
          </MagneticButton>
        ) : (
          <MagneticButton
            domain="id"
            variant="secondary"
            size="sm"
            accentColor="#14b8a6"
            onClick={() => navigate('/login')}
          >
            Sign In
          </MagneticButton>
        )}
      </div>
    </header>
  )
}
